// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"243":"e00cd67d","591":"36a7ebbc","821":"ef6f2d3d"}[chunkId] + ".chunk.css";
};